var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3335 8.67606C31.1524 8.0297 30.7994 7.44452 30.3122 6.98273C29.8113 6.50673 29.1973 6.16624 28.5282 5.99339C26.0242 5.33339 15.9922 5.33339 15.9922 5.33339C11.81 5.28581 7.62878 5.49509 3.47221 5.96006C2.80313 6.14568 2.19029 6.49378 1.68821 6.97339C1.19487 7.44806 0.837539 8.03339 0.650873 8.67473C0.202463 11.0904 -0.0154048 13.5432 0.000205884 16.0001C-0.0157941 18.4547 0.201539 20.9067 0.650873 23.3254C0.833539 23.9641 1.18954 24.5467 1.68421 25.0174C2.17887 25.4881 2.79487 25.8281 3.47221 26.0081C6.00954 26.6667 15.9922 26.6667 15.9922 26.6667C20.1798 26.7144 24.3663 26.5051 28.5282 26.0401C29.1973 25.8672 29.8113 25.5267 30.3122 25.0507C30.7992 24.589 31.1518 24.0038 31.3322 23.3574C31.7923 20.9427 32.016 18.4888 32.0002 16.0307C32.0348 13.5622 31.8114 11.0968 31.3335 8.67473V8.67606ZM12.8029 20.5654V11.4361L21.1495 16.0014L12.8029 20.5654Z",
    fill: "#2D89FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsYoutube);
export default __webpack_public_path__ + "static/media/icons_youtube.5c0d0a1e658e5ad6782a5e2b79bdd5da.svg";
export { ForwardRef as ReactComponent };